// extracted by mini-css-extract-plugin
module.exports = {"CenteredLogo":"CenteredLogo_CenteredLogo__7mAq9"};